document.querySelectorAll('.vendor-list__container__item__link').forEach(element => {
  element.addEventListener('mouseenter', function() {
    var dataValue = this.getAttribute('data-local');
    var dataDisplayDiv = document.getElementById('dataDisplay');
    dataDisplayDiv.innerHTML = dataValue;
    dataDisplayDiv.classList.add('visible');
  });
  
  element.addEventListener('mouseleave', function() {
    var dataDisplayDiv = document.getElementById('dataDisplay');
    dataDisplayDiv.innerHTML = '';
    dataDisplayDiv.classList.remove('visible');
  });
});